// 🤖 AUTO-GENERATED from data/components.json
// DO NOT EDIT MANUALLY - Changes will be overwritten
// Schema version: 1.0.0

import type { VoltraBaseProps } from '../baseProps'

export type ButtonProps = VoltraBaseProps & {
  /** Visual style of the button */
  buttonStyle?: 'automatic' | 'bordered' | 'borderedProminent' | 'plain' | 'borderless'
}
